__turbopack_context__.v({
  "addInfo": "style-module-scss-module__JcwklW__addInfo",
  "addInfo__btn": "style-module-scss-module__JcwklW__addInfo__btn",
  "addInfo__desc": "style-module-scss-module__JcwklW__addInfo__desc",
  "addInfo__iconArrow": "style-module-scss-module__JcwklW__addInfo__iconArrow",
  "addInfo__title": "style-module-scss-module__JcwklW__addInfo__title",
  "body": "style-module-scss-module__JcwklW__body",
});
